import React from "react";
import t from "../../../../../i18n";
import { H4 } from "@ui/Text";

export const FaultMultiSelectChartTooltip = ({
  pointsSelected,
}: {
  pointsSelected: Highcharts.Point[];
}) => (
  <H4>
    {t("diagnosis.chart.tooltip.selectedPoints", {
      count: pointsSelected.length,
    })}
  </H4>
);
